/**
 * WordPress "Google Ads results": turns the card grid into a slider on
 * small screens or when there are more than 4 cards (data-card-count).
 */
document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('parSliderGrid');
    var prev = document.getElementById('parPrev');
    var next = document.getElementById('parNext');
    var nav = document.getElementById('parSliderNav');
    if (!grid || !prev || !next || !nav) return;

    var cardCount = parseInt(grid.dataset.cardCount, 10) || 0;

    function updateButtons() {
        prev.disabled = grid.scrollLeft <= 0;
        next.disabled = grid.scrollLeft + grid.offsetWidth >= grid.scrollWidth - 2;
    }

    function checkSlider() {
        var shouldBeSlider = window.innerWidth < 1024 || cardCount > 4;
        grid.classList.toggle('is-slider', shouldBeSlider);
        nav.classList.toggle('is-visible', shouldBeSlider);
        if (shouldBeSlider) updateButtons();
    }

    function getScrollAmount() {
        var card = grid.querySelector('.par-card');
        return card ? card.offsetWidth + 24 : 300;
    }

    prev.addEventListener('click', function () {
        grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
        grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', checkSlider);
    checkSlider();
});
